export type StoreAttributeFieldValue = string | string[];
export type StoreAttributeFieldsBag = Record<string, StoreAttributeFieldValue>;
export interface Store {
    ClientKey?: string;
    Id: string;
    StoreName: string;
    AttributeFields?: StoreAttributeFieldsBag;
    Address1?: string;
    Address2?: string;
    City?: string;
    BannerId?: string;
    DivisionId?: string;
    DivisionName?: string;
    Country?: string;
    PostalCode?: string;
    Latitude?: string;
    Longitude?: string;
    State?: string;
    selected?: boolean;
}
